<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useNavigation } from '../useNavigation'
import type { Student2Context } from '@/types/student2'
import { useStaticAsset } from '@/composables/useStaticAsset'

const asset = useStaticAsset()

const props = defineProps<{ page: string; context: Student2Context }>()
const iframe = ref<HTMLIFrameElement | null>(null)
const pageRef = ref<HTMLElement | null>(null)
const { getLink, goto } = useNavigation()

const onPageLoad = () => {
  if (!iframe.value?.contentDocument) return
  const fDocument = iframe.value.contentDocument
  const body = fDocument.body
  const html = fDocument.documentElement
  const contentHeight =
    Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) + 200
  iframe.value.style.height = `${contentHeight}px`

  fDocument.querySelectorAll<HTMLAnchorElement>('a[data-goto-page]').forEach(a => {
    if (a.href) return
    const page = a.dataset.gotoPage
    const hash = a.dataset.pageHash
    a.href = getLink({ tab: page, hash })
    a.addEventListener('click', event => {
      event.preventDefault()
      goto(a.href)
    })
  })

  if (window.location.hash) fDocument.querySelector(window.location.hash)?.scrollIntoView()
  if (['not_ready', 'video_only'].includes(props.context.smartbook?.development_state)) {
    fDocument.querySelector('#dev-state')?.removeAttribute('hidden')
  }
}

let resizeObserver: ResizeObserver | null = null
onMounted(() => {
  resizeObserver = new ResizeObserver(onPageLoad)
  if (pageRef.value) resizeObserver.observe(pageRef.value)
})
onBeforeUnmount(() => resizeObserver?.disconnect())
</script>

<template>
  <section ref="pageRef" class="student-cabinet__page student-parent-info-page">
    <header><img :src="asset('img/logo.svg')" height="64" /></header>

    <iframe
      ref="iframe"
      class="student-parent-info-page__iframe"
      frameborder="0"
      :src="`/student/parent_info/${page}`"
      @load="onPageLoad"
    />
  </section>
</template>

<style lang="scss">
.student-parent-info-page {
  padding: 0 max(24px, calc((100% - 800px) / 2));
  padding-top: var(--header_height, 0);

  &__iframe {
    width: 100%;
  }
}
</style>
